import { apiSlice } from "./apiSlice";
import { COMPANY_URL } from "../constants";

const companyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCompany: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/createCompany`,
        method: "POST",
        body: data,
        // headers: {
        //   Authorization: `Bearer ${data.token}`,
        // },
      }),
    }),
    getCompanyById: builder.query({
      query: (data) => ({
        url: `${COMPANY_URL}/getMyCompany`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    editCompanyDetails: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/editCompanyDetails`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    uploadCompanyPhoto: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/uploadCompanyPhoto`,
        method: "POST",
        body: data.payload,
      }),
    }),
  }),
});

export const {
  useCreateCompanyMutation,
  useGetCompanyByIdQuery,
  useEditCompanyDetailsMutation,
  useUploadCompanyPhotoMutation,
} = companyApiSlice;
